<template>
  <div class="text-darkBlue my-12">
    <div class="flex flex-wrap justify-between">
      <div class="mt-2">
        <p class="font-semibold text-lg">Two Factor Authentication</p>
        <p class="text-sm">
          Protect your account with 2-Step Verification.
          <tool-tip
            text="Each time you sign in to your MuleEX Account, you'll need your password and a verification code."
          />
        </p>
      </div>
      <div class="mt-2" v-if="!setup2fa">
        <base-button
          text="Configure" 
          background="bg-transparent"
          border="border border-darkBlue"
          @click="showTwoFaModal = true"
        />
      </div>
    </div>
   

    <TwoFactorModal
    @close-modal="showTwoFaModal = false"
    :show-modal="showTwoFaModal"
    />
  </div>
</template>

<script>
import changeInputField from "@/mixins/changeInput";
import TwoFactorModal from "../Modal/Two_FA_Modal.vue";

export default {
    data() {
        return {
            showTwoFaModal: false,
            setup2fa: false,
            password: "",
            authenticationCode: {
                first: "",
                second: "",
                third: "",
                fourth: "",
                fifth: "",
                sixth: "",
            },
            email: "",
            verifyingAuthCode: false,
            isCreatePassword: false,
            codeSubmitted: false,
            loading: false,
            successfullyVerified: false,
            verificationResent: false,
            resendingVerificationCode: false,
            codeVerified: false,
            requestingOtp: false,
            verifyingOtp: false,
            isInvalidOtp: false,
        };
    },
    mixins: [changeInputField],
    methods: {
        async requestOtp() {
            this.requestingOtp = true;
            this.isInvalidOtp = false;
            let payload = {
                email: this.email,
            };
            let userId = localStorage.getItem("userId");
            payload.userId = userId;
            try {
                await this.$_requestOtp(payload);
                this.requestingOtp = false;
                this.generateToast("An OTP has been sent to your email!", "success");
            }
            catch (error) {
                this.handleError(error);
                this.requestingOtp = false;
            }
        },
        async submitOtp() {
            this.verifyingOtp = true;
            let { first, second, third, fourth, fifth, sixth } = this.authenticationCode;
            let code = first + second + third + fourth + fifth + sixth;
            let payload = {
                token: code,
            };
            let userId = localStorage.getItem("userId");
            payload.userId = userId;
            try {
                let response = await this.$_sendToken(payload);
                this.log(response);
                this.generateToast("Two factor authentication has been enabled on your account!", "success");
            }
            catch (error) {
                this.handleError(error);
                this.isInvalidOtp = true;
                this.verifyingOtp = false;
            }
        },
        pasteCode(e) {
            e.preventDefault();
            let code = e.clipboardData.getData("text/plain");
            console.log("Code:", code);
            if (code.length == 6) {
                this.authenticationCode = {
                    first: code.charAt(0),
                    second: code.charAt(1),
                    third: code.charAt(2),
                    fourth: code.charAt(3),
                    fifth: code.charAt(4),
                    sixth: code.charAt(5),
                };
            }
            else {
                this.generateToast("Invalid code entered!", "error");
                this.authenticationCode.first = "";
            }
        },
    },
    components: { TwoFactorModal }
};
</script>

<style scoped>
.single-code-input {
  width: 3rem;
  height: 3rem;
  background: #ffffff;
  border: 1px solid #b8c4de;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 1rem;
  margin-right: 0.55rem;
}
.single-code-input::placeholder {
  font-weight: normal;
  font-size: 1rem;
}
.single-code-input[type="text"] {
  font-size: 2.3rem;
  text-align: center;
  font-weight: bold;
  color: rgba(82, 82, 82, 0.3);
}
</style>
